/* istanbul ignore file */

import { IFetch } from '../../../models/IFetch';
import { headers } from '../../../utils/FetchHeader';

export default {
  getComparatorData: ({ channel, origin, position, tenantId, productId, clacomId }): IFetch => ({
    url: `/s/products/v2/${tenantId}/recommendations?channel=${channel}&origin=${origin}&productId=${productId}&position=${position}&clacomId=${clacomId}`,
    params: {
      method: 'GET',
      headers: headers(),
    },
  }),
};
